import {
  createMemoryHistory,
  createRouter as createVueRouter,
  createWebHistory,
  type RouterOptions
} from 'vue-router'
import { ROUTER_BASE_PATH } from '@/constants/links'

const routes: RouterOptions['routes'] = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/home/index.vue')
  },
  {
    path: '/academy',
    name: 'Academy',
    component: () => import('@/views/promotion-institute/index.vue')
  }
]

export function createRouter() {
  return createVueRouter({
    history: import.meta.env.SSR
      ? createMemoryHistory(ROUTER_BASE_PATH)
      : createWebHistory(ROUTER_BASE_PATH),
    routes
  })
}
